/* tslint:disable */
/* eslint-disable */
/**
 * Unnamed Galvyn API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddExtraDnsRecordRequest,
  AddRuleToRulesetRequest,
  AddTenantDomainRequest,
  ApiErrorResponse,
  CheckDeviceAccessRequest,
  CheckDeviceAccessResponse,
  CreateAccessRuleRequest,
  CreateDeviceGroupRequest,
  CreateExtraDnsRecordsRequest,
  CreateLocalGroupRequest,
  CreateOidcProvider200Response,
  CreateOidcProviderRequest,
  CreatePreAuthKeyRequest,
  CreatePreAuthKeyResponse,
  CreateRulesetInstanceRequest,
  CreateRulesetRequest,
  CreateSplitDnsDomainRequest,
  CreateSplitDnsResolverRequest,
  CreateSubnetWithFstRouterRequest,
  CreateTagDirectoryRequest,
  CreateTagRequest,
  CreateTenant200Response,
  CreateTenantRequest,
  DeviceFromIpResponse,
  DevicesFromNameResponse,
  EnableSubnetRequest,
  FormErrorResponseForAddTenantDomainErrors,
  FormErrorResponseForCreateExtraDnsRecordsError,
  FormErrorResponseForInsertDnsSearchDomainError,
  FormErrorResponseForInsertTenantSearchDomainErrors,
  FormErrorResponseForSetDeviceDnsnameErrors,
  FormErrorResponseForUpdateExtraDnsDomainError,
  FormErrorResponseForUpdateOidcProviderErrors,
  FormErrorResponseForUpdateTenantErrors,
  FormResultForNullAndAddMemberToLocalGroupError,
  FormResultForNullAndCreateSplitDnsDomainError,
  FormResultForNullAndCreateSplitDnsResolverErrors,
  FormResultForNullAndCreateTagDirectoryErrors,
  FormResultForNullAndDeleteDeviceGroupErrors,
  FormResultForNullAndDeleteLocalGroupErrors,
  FormResultForNullAndDeleteTagErrors,
  FormResultForNullAndExtraDnsRecordError,
  FormResultForNullAndSetDeviceGroupNameErrors,
  FormResultForNullAndSetGeneralSettingsErrors,
  FormResultForNullAndSetLdapConnectionSettingsErrors,
  FormResultForNullAndSetLdapSettingsErrors,
  FormResultForNullAndSetTagNameErrors,
  FormResultForNullAndUpdateExtraDnsRecordError,
  FormResultForNullAndUpdateGlobalDnsErrors,
  FormResultForNullAndUpdateSplitDnsDomainError,
  FormResultForNullAndUpdateSplitDnsResolverErrors,
  FormResultForNullAndUpdateTagDirectoryErrors,
  FormResultForSimpleInvitationLinkAndInviteUserErrors,
  FormResultForSingleUuidAndCreateDeviceGroupErrors,
  FormResultForSingleUuidAndCreateLocalGroupErrors,
  FormResultForSingleUuidAndCreateTagErrors,
  FormResultForTestLdapSearchResponseAndTestLdapSettingsErrors,
  FullGlobalDns,
  FullLdapSettings,
  FullPluginSchema,
  FullRulesetInstance,
  GetAccessGraphResponse,
  GetAccessProblemsResponse,
  GetAllAccessRuleOptionsResponse,
  GetAllDeviceGroupsRequest,
  GetAllDevicesResponse,
  GetAllExitNodesRequest,
  GetAllGroupsRequest,
  GetAllPluginsRequest,
  GetAllPluginsResponse,
  GetAllSubnetsRequest,
  GetAllTagDirectoriesResponse,
  GetAllTagsRequest,
  GetChangelogRequest,
  GetEphemeralDeviceSettingsResponse,
  GetGeneralSettingsResponse,
  GetLocalAuthRequirementsResponse,
  GetOidcSettingsResponse,
  GetPendingExitNodesRequest,
  GetPendingRoutesRequest,
  GetRulesetResponse,
  GetRulesetsPageRequest,
  GetScimSettingsResponse,
  GetSingleDeviceGroupResponse,
  GetSingleDeviceResponse,
  GetSingleGroupMembersRequest,
  GetSingleGroupResponse,
  GetSinglePluginResponse,
  GetSingleSubnetResponse,
  GetSingleTagResponse,
  GetSingleUserResponse,
  GetTenantSearchDomainsResponse,
  GetUserNotInGroupRequest,
  InsertDnsSearchDomainRequest,
  InsertTenantSearchDomainRequest,
  InviteUserRequest,
  ListForFullAccessRule,
  ListForFullExtraDnsDomain,
  ListForFullHeadscalePreAuthKey,
  ListForFullSplitDnsDomain,
  ListForGetAllUsersResponse,
  ListForGetTenantSplitDomainsResponseItem,
  ListForSimpleAccount,
  ListForSimpleChangelogEntry,
  ListForSimpleDnsSearchDomain,
  ListForSimpleExtraDnsDomain,
  ListForSimpleOidcProvider,
  ListForSimpleTagDirectory,
  ListForSimpleTenant,
  ListForSimpleUser,
  MapResponse,
  MoveDnsSearchDomainRequest,
  MoveTagToAnotherDirectoryRequest,
  MoveTenantSearchDomainRequest,
  OptionalForSimpleGroup,
  PageForGetAllGroupsResponseItem,
  PageForGetAllSubnetsResponseItem,
  PageForGetExitNodesResponseItem,
  PageForGetPendingRoutesResponseItem,
  PageForGetRulesetsPageResponse,
  PageForSimpleChangelogEntry,
  PageForSimpleDeviceGroup,
  PageForSimpleUser,
  RecreateInvitationRequest,
  RejectPendingSubnetRouterRequest,
  RemoveTenantDomainRequest,
  RenewUserAccessRequest,
  SetDeviceDnsnameRequest,
  SetDeviceGroupDescriptionRequest,
  SetDeviceGroupNameRequest,
  SetEphemeralDeviceSettingsRequest,
  SetGeneralSettingsRequest,
  SetLdapConnectionSettingsRequest,
  SetLdapQuerySettingsRequest,
  SetLocalAuthRequirementsRequest,
  SetOidcSettingsRequest,
  SetScimSettingsRequest,
  SetSubnetDescriptionRequest,
  SetTagDescriptionRequest,
  SetTagNameRequest,
  SimpleOidcProvider,
  SimpleTenant,
  SingleUuid,
  TenantDeletePreviewResponse,
  UpdateAccessRuleRequest,
  UpdateExtraDnsDomainRequest,
  UpdateExtraDnsRecordRequest,
  UpdateGroupRequest,
  UpdateOidcProviderRequest,
  UpdateRuleInRulesetRequest,
  UpdateRulesetRequest,
  UpdateSplitDnsDomainRequest,
  UpdateSplitDnsResolverRequest,
  UpdateTagDirectoryRequest,
  UpdateTenantRequest,
} from '../models/index';

export interface AddDeviceTagRequest {
    uuid: string;
    SingleUuid?: SingleUuid;
}

export interface AddDeviceToDeviceGroupRequest {
    device_uuid: string;
    SingleUuid?: SingleUuid;
}

export interface AddDomainToSplitDnsRequest {
    CreateSplitDnsDomainRequest?: CreateSplitDnsDomainRequest;
}

export interface AddLocalGroupMemberRequest {
    uuid: string;
    SingleUuid?: SingleUuid;
}

export interface AddRecordToExtraDnsRequest {
    uuid: string;
    AddExtraDnsRecordRequest?: AddExtraDnsRecordRequest;
}

export interface AddResolverToDomainInSplitDnsRequest {
    domain_uuid: string;
    CreateSplitDnsResolverRequest?: CreateSplitDnsResolverRequest;
}

export interface AddRuleToRulesetOperationRequest {
    ruleset_uuid: string;
    AddRuleToRulesetRequest?: AddRuleToRulesetRequest;
}

export interface AddSubnetRouterRequest {
    subnet_uuid: string;
    device_uuid: string;
}

export interface AddTenantDomainOperationRequest {
    tenant_uuid: string;
    AddTenantDomainRequest?: AddTenantDomainRequest;
}

export interface ApprovePendingExitNodeRequest {
    uuid: string;
}

export interface CheckDeviceAccessOperationRequest {
    CheckDeviceAccessRequest?: CheckDeviceAccessRequest;
}

export interface CreateAccessRuleOperationRequest {
    CreateAccessRuleRequest?: CreateAccessRuleRequest;
}

export interface CreateDeviceGroupOperationRequest {
    CreateDeviceGroupRequest?: CreateDeviceGroupRequest;
}

export interface CreateDirectoryRequest {
    CreateTagDirectoryRequest?: CreateTagDirectoryRequest;
}

export interface CreateExtraDnsRecordsOperationRequest {
    CreateExtraDnsRecordsRequest?: CreateExtraDnsRecordsRequest;
}

export interface CreateLocalGroupOperationRequest {
    CreateLocalGroupRequest?: CreateLocalGroupRequest;
}

export interface CreateOidcProviderOperationRequest {
    CreateOidcProviderRequest?: CreateOidcProviderRequest;
}

export interface CreatePreAuthKeyOperationRequest {
    CreatePreAuthKeyRequest?: CreatePreAuthKeyRequest;
}

export interface CreateRulesetOperationRequest {
    CreateRulesetRequest?: CreateRulesetRequest;
}

export interface CreateRulesetInstanceOperationRequest {
    CreateRulesetInstanceRequest?: CreateRulesetInstanceRequest;
}

export interface CreateSubnetWithFstRouterOperationRequest {
    CreateSubnetWithFstRouterRequest?: CreateSubnetWithFstRouterRequest;
}

export interface CreateTagOperationRequest {
    CreateTagRequest?: CreateTagRequest;
}

export interface CreateTenantOperationRequest {
    CreateTenantRequest?: CreateTenantRequest;
}

export interface DeleteAccessRuleRequest {
    uuid: string;
}

export interface DeleteAccountRequest {
    uuid: string;
}

export interface DeleteDeviceRequest {
    uuid: string;
}

export interface DeleteDeviceGroupRequest {
    device_group_uuid: string;
}

export interface DeleteDirectoryRequest {
    directory_uuid: string;
}

export interface DeleteDomainFromSplitDnsRequest {
    domain_uuid: string;
}

export interface DeleteExitNodeRequest {
    uuid: string;
}

export interface DeleteExtraDnsDomainRequest {
    uuid: string;
}

export interface DeleteExtraDnsRecordRequest {
    uuid: string;
}

export interface DeleteLocalGroupRequest {
    uuid: string;
}

export interface DeleteLocalOrInvitedUserRequest {
    user_uuid: string;
}

export interface DeleteOidcProviderRequest {
    provider_uuid: string;
}

export interface DeletePluginRequest {
    plugin_uuid: string;
}

export interface DeleteResolverFromDomainInSplitDnsRequest {
    resolver_uuid: string;
}

export interface DeleteRuleFromRulesetRequest {
    rule_uuid: string;
}

export interface DeleteRulesetRequest {
    ruleset_uuid: string;
}

export interface DeleteRulesetInstanceRequest {
    instance_uuid: string;
}

export interface DeleteSubnetRequest {
    subnet_uuid: string;
}

export interface DeleteTagRequest {
    uuid: string;
}

export interface DeleteTenantRequest {
    tenant_uuid: string;
}

export interface DisableExitNodeRequest {
    uuid: string;
}

export interface DisableSubnetRequest {
    subnet_uuid: string;
}

export interface DumpDeviceStateRequest {
    uuid: string;
}

export interface EnableExitNodeRequest {
    uuid: string;
}

export interface EnableSubnetOperationRequest {
    subnet_uuid: string;
    EnableSubnetRequest?: EnableSubnetRequest;
}

export interface ExpireDeviceRequest {
    uuid: string;
}

export interface ExpireInvitationRequest {
    user_uuid: string;
}

export interface ExpireKeyRequest {
    uuid: string;
}

export interface ExpireUserDevicesRequest {
    uuid: string;
}

export interface GetAllApprovedExitNodesRequest {
    GetAllExitNodesRequest?: GetAllExitNodesRequest;
}

export interface GetAllDeviceGroupsOperationRequest {
    GetAllDeviceGroupsRequest?: GetAllDeviceGroupsRequest;
}

export interface GetAllExtraDnsRequest {
    filter_dns?: string | null;
}

export interface GetAllGroupsOperationRequest {
    GetAllGroupsRequest?: GetAllGroupsRequest;
}

export interface GetAllPluginsOperationRequest {
    GetAllPluginsRequest?: GetAllPluginsRequest;
}

export interface GetAllSubnetsOperationRequest {
    GetAllSubnetsRequest?: GetAllSubnetsRequest;
}

export interface GetAllTagsOperationRequest {
    GetAllTagsRequest?: GetAllTagsRequest;
}

export interface GetChangelogOperationRequest {
    GetChangelogRequest?: GetChangelogRequest;
}

export interface GetDeletePreviewRequest {
    tenant_uuid: string;
}

export interface GetDeviceExtraDnsRequest {
    uuid: string;
}

export interface GetDeviceFromIpRequest {
    ip?: string;
}

export interface GetDeviceGroupRequest {
    device_group_uuid: string;
}

export interface GetDevicesFromNameRequest {
    name?: string;
}

export interface GetLdapSettingsRequest {
    tenant_uuid: string;
}

export interface GetOidcSettingsRequest {
    tenant_uuid: string;
}

export interface GetPendingExitNodesOperationRequest {
    GetPendingExitNodesRequest?: GetPendingExitNodesRequest;
}

export interface GetPendingSubnetRoutesRequest {
    GetPendingRoutesRequest?: GetPendingRoutesRequest;
}

export interface GetPluginVersionRequest {
    plugin_uuid: string;
    version: string;
}

export interface GetPossibleExtraDnsForDeviceRequest {
    uuid: string;
}

export interface GetRulesetRequest {
    ruleset_uuid: string;
}

export interface GetRulesetInstanceRequest {
    instance_uuid: string;
}

export interface GetRulesetsPageOperationRequest {
    GetRulesetsPageRequest?: GetRulesetsPageRequest;
}

export interface GetScimSettingsRequest {
    tenant_uuid: string;
}

export interface GetSingleDeviceRequest {
    uuid: string;
}

export interface GetSingleGroupRequest {
    uuid: string;
}

export interface GetSingleGroupMembersOperationRequest {
    uuid: string;
    GetSingleGroupMembersRequest?: GetSingleGroupMembersRequest;
}

export interface GetSingleOidcProviderRequest {
    provider_uuid: string;
}

export interface GetSinglePluginRequest {
    plugin_uuid: string;
}

export interface GetSingleSubnetRequest {
    subnet_uuid: string;
}

export interface GetSingleTenantRequest {
    tenant_uuid: string;
}

export interface GetSingleUserRequest {
    uuid: string;
}

export interface GetTagRequest {
    uuid: string;
}

export interface GetTenantDomainsRequest {
    tenant_uuid: string;
}

export interface GetTenantSearchDomainsRequest {
    tenant_uuid: string;
}

export interface GetUsersNotInGroupRequest {
    uuid: string;
    GetUserNotInGroupRequest?: GetUserNotInGroupRequest;
}

export interface InsertDnsSearchDomainOperationRequest {
    InsertDnsSearchDomainRequest?: InsertDnsSearchDomainRequest;
}

export interface InsertTenantDnsSearchDomainRequest {
    tenant_uuid: string;
    InsertTenantSearchDomainRequest?: InsertTenantSearchDomainRequest;
}

export interface InstallPluginRequest {
    plugin_uuid: string;
}

export interface InviteUserOperationRequest {
    InviteUserRequest?: InviteUserRequest;
}

export interface MoveDnsSearchDomainOperationRequest {
    MoveDnsSearchDomainRequest?: MoveDnsSearchDomainRequest;
}

export interface MoveTagToOtherDirectoryRequest {
    MoveTagToAnotherDirectoryRequest?: MoveTagToAnotherDirectoryRequest;
}

export interface MoveTenantDnsSearchDomainRequest {
    tenant_uuid: string;
    MoveTenantSearchDomainRequest?: MoveTenantSearchDomainRequest;
}

export interface RecreateInvitationOperationRequest {
    user_uuid: string;
    RecreateInvitationRequest?: RecreateInvitationRequest;
}

export interface RejectPendingExitNodeRequest {
    uuid: string;
}

export interface RejectPendingSubnetRouterOperationRequest {
    RejectPendingSubnetRouterRequest?: RejectPendingSubnetRouterRequest;
}

export interface RemoveDeviceFromDeviceGroupRequest {
    device_uuid: string;
    SingleUuid?: SingleUuid;
}

export interface RemoveDeviceTagRequest {
    uuid: string;
    SingleUuid?: SingleUuid;
}

export interface RemoveDnsSearchDomainRequest {
    domain_index: number;
}

export interface RemoveLocalGroupMemberRequest {
    uuid: string;
    SingleUuid?: SingleUuid;
}

export interface RemoveSubnetRouterRequest {
    subnet_uuid: string;
    device_uuid: string;
}

export interface RemoveTenantDnsSearchDomainRequest {
    tenant_uuid: string;
    domain_index: number;
}

export interface RemoveTenantDomainOperationRequest {
    tenant_uuid: string;
    RemoveTenantDomainRequest?: RemoveTenantDomainRequest;
}

export interface RenewUserAccessOperationRequest {
    user_uuid: string;
    RenewUserAccessRequest?: RenewUserAccessRequest;
}

export interface RevokeUserAccessRequest {
    user_uuid: string;
}

export interface SetDeviceDnsnameOperationRequest {
    uuid: string;
    SetDeviceDnsnameRequest?: SetDeviceDnsnameRequest;
}

export interface SetDeviceGroupDescriptionOperationRequest {
    device_group_uuid: string;
    SetDeviceGroupDescriptionRequest?: SetDeviceGroupDescriptionRequest;
}

export interface SetDeviceGroupNameOperationRequest {
    device_group_uuid: string;
    SetDeviceGroupNameRequest?: SetDeviceGroupNameRequest;
}

export interface SetDeviceStateDebugOnlyRequest {
    uuid: string;
    MapResponse?: MapResponse;
}

export interface SetEphemeralDeviceSettingsOperationRequest {
    SetEphemeralDeviceSettingsRequest?: SetEphemeralDeviceSettingsRequest;
}

export interface SetGeneralSettingsOperationRequest {
    SetGeneralSettingsRequest?: SetGeneralSettingsRequest;
}

export interface SetLdapConnectionSettingsOperationRequest {
    tenant_uuid: string;
    SetLdapConnectionSettingsRequest?: SetLdapConnectionSettingsRequest;
}

export interface SetLdapQuerySettingsOperationRequest {
    tenant_uuid: string;
    SetLdapQuerySettingsRequest?: SetLdapQuerySettingsRequest;
}

export interface SetLocalAuthRequirementsOperationRequest {
    SetLocalAuthRequirementsRequest?: SetLocalAuthRequirementsRequest;
}

export interface SetOidcSettingsOperationRequest {
    tenant_uuid: string;
    SetOidcSettingsRequest?: SetOidcSettingsRequest;
}

export interface SetPortalAccessGroupRequest {
    SingleUuid?: SingleUuid;
}

export interface SetScimSettingsOperationRequest {
    tenant_uuid: string;
    SetScimSettingsRequest?: SetScimSettingsRequest;
}

export interface SetSubnetDescriptionOperationRequest {
    subnet_uuid: string;
    SetSubnetDescriptionRequest?: SetSubnetDescriptionRequest;
}

export interface SetTagDescriptionOperationRequest {
    tag_uuid: string;
    SetTagDescriptionRequest?: SetTagDescriptionRequest;
}

export interface SetTagNameOperationRequest {
    tag_uuid: string;
    SetTagNameRequest?: SetTagNameRequest;
}

export interface TestLdapQuerySettingsRequest {
    tenant_uuid: string;
    SetLdapQuerySettingsRequest?: SetLdapQuerySettingsRequest;
}

export interface UpdateAccessRuleOperationRequest {
    uuid: string;
    UpdateAccessRuleRequest?: UpdateAccessRuleRequest;
}

export interface UpdateDirectoryRequest {
    directory_uuid: string;
    UpdateTagDirectoryRequest?: UpdateTagDirectoryRequest;
}

export interface UpdateDomainInSplitDnsRequest {
    domain_uuid: string;
    UpdateSplitDnsDomainRequest?: UpdateSplitDnsDomainRequest;
}

export interface UpdateExtraDnsDomainOperationRequest {
    uuid: string;
    UpdateExtraDnsDomainRequest?: UpdateExtraDnsDomainRequest;
}

export interface UpdateExtraDnsRecordOperationRequest {
    uuid: string;
    UpdateExtraDnsRecordRequest?: UpdateExtraDnsRecordRequest;
}

export interface UpdateGlobalDnsRequest {
    FullGlobalDns?: FullGlobalDns;
}

export interface UpdateGroupOperationRequest {
    uuid: string;
    UpdateGroupRequest?: UpdateGroupRequest;
}

export interface UpdateOidcProviderOperationRequest {
    provider_uuid: string;
    UpdateOidcProviderRequest?: UpdateOidcProviderRequest;
}

export interface UpdatePluginRequest {
    plugin_uuid: string;
}

export interface UpdateResolverInDomainInSplitDnsRequest {
    resolver_uuid: string;
    UpdateSplitDnsResolverRequest?: UpdateSplitDnsResolverRequest;
}

export interface UpdateRuleInRulesetOperationRequest {
    rule_uuid: string;
    UpdateRuleInRulesetRequest?: UpdateRuleInRulesetRequest;
}

export interface UpdateRulesetOperationRequest {
    ruleset_uuid: string;
    UpdateRulesetRequest?: UpdateRulesetRequest;
}

export interface UpdateTenantOperationRequest {
    tenant_uuid: string;
    UpdateTenantRequest?: UpdateTenantRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async addDeviceTagRaw(requestParameters: AddDeviceTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling addDeviceTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/add-tag`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addDeviceTag(requestParameters: AddDeviceTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addDeviceTagRaw(requestParameters, initOverrides);
    }

    /**
     */
    async addDeviceToDeviceGroupRaw(requestParameters: AddDeviceToDeviceGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['device_uuid'] == null) {
            throw new runtime.RequiredError(
                'device_uuid',
                'Required parameter "device_uuid" was null or undefined when calling addDeviceToDeviceGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{device_uuid}/add-to-device-group`.replace(`{${"device_uuid"}}`, encodeURIComponent(String(requestParameters['device_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addDeviceToDeviceGroup(requestParameters: AddDeviceToDeviceGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addDeviceToDeviceGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Add new domain to split dns
     * Add new domain to split dns
     */
    async addDomainToSplitDnsRaw(requestParameters: AddDomainToSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndCreateSplitDnsDomainError>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/add-domain`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateSplitDnsDomainRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Add new domain to split dns
     * Add new domain to split dns
     */
    async addDomainToSplitDns(requestParameters: AddDomainToSplitDnsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndCreateSplitDnsDomainError> {
        const response = await this.addDomainToSplitDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async addLocalGroupMemberRaw(requestParameters: AddLocalGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndAddMemberToLocalGroupError>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling addLocalGroupMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/local/{uuid}/add-member`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async addLocalGroupMember(requestParameters: AddLocalGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndAddMemberToLocalGroupError> {
        const response = await this.addLocalGroupMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async addRecordToExtraDnsRaw(requestParameters: AddRecordToExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndExtraDnsRecordError>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling addRecordToExtraDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/add-record-to-extra-dns`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddExtraDnsRecordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async addRecordToExtraDns(requestParameters: AddRecordToExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndExtraDnsRecordError> {
        const response = await this.addRecordToExtraDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds new resolver to domain
     * Adds new resolver to domain
     */
    async addResolverToDomainInSplitDnsRaw(requestParameters: AddResolverToDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndCreateSplitDnsResolverErrors>> {
        if (requestParameters['domain_uuid'] == null) {
            throw new runtime.RequiredError(
                'domain_uuid',
                'Required parameter "domain_uuid" was null or undefined when calling addResolverToDomainInSplitDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/add-resolver/{domain_uuid}`.replace(`{${"domain_uuid"}}`, encodeURIComponent(String(requestParameters['domain_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateSplitDnsResolverRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Adds new resolver to domain
     * Adds new resolver to domain
     */
    async addResolverToDomainInSplitDns(requestParameters: AddResolverToDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndCreateSplitDnsResolverErrors> {
        const response = await this.addResolverToDomainInSplitDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a rule to a ruleset
     * Adds a rule to a ruleset
     */
    async addRuleToRulesetRaw(requestParameters: AddRuleToRulesetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['ruleset_uuid'] == null) {
            throw new runtime.RequiredError(
                'ruleset_uuid',
                'Required parameter "ruleset_uuid" was null or undefined when calling addRuleToRuleset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/rulesets/{ruleset_uuid}/add-rule`.replace(`{${"ruleset_uuid"}}`, encodeURIComponent(String(requestParameters['ruleset_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddRuleToRulesetRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds a rule to a ruleset
     * Adds a rule to a ruleset
     */
    async addRuleToRuleset(requestParameters: AddRuleToRulesetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addRuleToRulesetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async addSubnetRouterRaw(requestParameters: AddSubnetRouterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subnet_uuid'] == null) {
            throw new runtime.RequiredError(
                'subnet_uuid',
                'Required parameter "subnet_uuid" was null or undefined when calling addSubnetRouter().'
            );
        }

        if (requestParameters['device_uuid'] == null) {
            throw new runtime.RequiredError(
                'device_uuid',
                'Required parameter "device_uuid" was null or undefined when calling addSubnetRouter().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/{subnet_uuid}/add-router/{device_uuid}`.replace(`{${"subnet_uuid"}}`, encodeURIComponent(String(requestParameters['subnet_uuid']))).replace(`{${"device_uuid"}}`, encodeURIComponent(String(requestParameters['device_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async addSubnetRouter(requestParameters: AddSubnetRouterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addSubnetRouterRaw(requestParameters, initOverrides);
    }

    /**
     */
    async addTenantDomainRaw(requestParameters: AddTenantDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForAddTenantDomainErrors>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling addTenantDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-dns/{tenant_uuid}/add-domain`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddTenantDomainRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async addTenantDomain(requestParameters: AddTenantDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForAddTenantDomainErrors> {
        const response = await this.addTenantDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async approvePendingExitNodeRaw(requestParameters: ApprovePendingExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling approvePendingExitNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/approve-pending-exit-node/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async approvePendingExitNode(requestParameters: ApprovePendingExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.approvePendingExitNodeRaw(requestParameters, initOverrides);
    }

    /**
     * Check access between two devices
     * Check access between two devices
     */
    async checkDeviceAccessRaw(requestParameters: CheckDeviceAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckDeviceAccessResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-visualization/check-access`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CheckDeviceAccessRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Check access between two devices
     * Check access between two devices
     */
    async checkDeviceAccess(requestParameters: CheckDeviceAccessOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckDeviceAccessResponse> {
        const response = await this.checkDeviceAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * No-op endpoint to verify the identity of the caller (internal user) to authenticate to the wiki
     * No-op endpoint to verify the identity of the caller (internal user) to authenticate to the wiki
     */
    async checkWikiAccessRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/accounts/wiki-access`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * No-op endpoint to verify the identity of the caller (internal user) to authenticate to the wiki
     * No-op endpoint to verify the identity of the caller (internal user) to authenticate to the wiki
     */
    async checkWikiAccess(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.checkWikiAccessRaw(initOverrides);
    }

    /**
     */
    async createAccessRuleRaw(requestParameters: CreateAccessRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleUuid>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateAccessRuleRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createAccessRule(requestParameters: CreateAccessRuleOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleUuid> {
        const response = await this.createAccessRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createDeviceGroupRaw(requestParameters: CreateDeviceGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForSingleUuidAndCreateDeviceGroupErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/device-groups/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateDeviceGroupRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createDeviceGroup(requestParameters: CreateDeviceGroupOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForSingleUuidAndCreateDeviceGroupErrors> {
        const response = await this.createDeviceGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createDirectoryRaw(requestParameters: CreateDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndCreateTagDirectoryErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/create-directory`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateTagDirectoryRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createDirectory(requestParameters: CreateDirectoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndCreateTagDirectoryErrors> {
        const response = await this.createDirectoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createExtraDnsRecordsRaw(requestParameters: CreateExtraDnsRecordsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForCreateExtraDnsRecordsError>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/create-extra-dns-records`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateExtraDnsRecordsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createExtraDnsRecords(requestParameters: CreateExtraDnsRecordsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForCreateExtraDnsRecordsError> {
        const response = await this.createExtraDnsRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createLocalGroupRaw(requestParameters: CreateLocalGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForSingleUuidAndCreateLocalGroupErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/local/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateLocalGroupRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createLocalGroup(requestParameters: CreateLocalGroupOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForSingleUuidAndCreateLocalGroupErrors> {
        const response = await this.createLocalGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createOidcProviderRaw(requestParameters: CreateOidcProviderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOidcProvider200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/oidc-provider/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateOidcProviderRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createOidcProvider(requestParameters: CreateOidcProviderOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOidcProvider200Response> {
        const response = await this.createOidcProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createPreAuthKeyRaw(requestParameters: CreatePreAuthKeyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePreAuthKeyResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/pre-auth-keys/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreatePreAuthKeyRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createPreAuthKey(requestParameters: CreatePreAuthKeyOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePreAuthKeyResponse> {
        const response = await this.createPreAuthKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new (empty) ruleset
     * Creates a new (empty) ruleset
     */
    async createRulesetRaw(requestParameters: CreateRulesetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleUuid>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/rulesets/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateRulesetRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Creates a new (empty) ruleset
     * Creates a new (empty) ruleset
     */
    async createRuleset(requestParameters: CreateRulesetOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleUuid> {
        const response = await this.createRulesetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new instance of a `Ruleset` applying it to a concrete `src` and `dst`
     * Creates a new instance of a `Ruleset` applying it to a concrete `src` and `dst`
     */
    async createRulesetInstanceRaw(requestParameters: CreateRulesetInstanceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SingleUuid>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/ruleset-instances/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateRulesetInstanceRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Creates a new instance of a `Ruleset` applying it to a concrete `src` and `dst`
     * Creates a new instance of a `Ruleset` applying it to a concrete `src` and `dst`
     */
    async createRulesetInstance(requestParameters: CreateRulesetInstanceOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SingleUuid> {
        const response = await this.createRulesetInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createSubnetWithFstRouterRaw(requestParameters: CreateSubnetWithFstRouterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/create-with-fst-router`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateSubnetWithFstRouterRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createSubnetWithFstRouter(requestParameters: CreateSubnetWithFstRouterOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createSubnetWithFstRouterRaw(requestParameters, initOverrides);
    }

    /**
     */
    async createTagRaw(requestParameters: CreateTagOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForSingleUuidAndCreateTagErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateTagRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createTag(requestParameters: CreateTagOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForSingleUuidAndCreateTagErrors> {
        const response = await this.createTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createTenantRaw(requestParameters: CreateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTenant200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateTenantRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async createTenant(requestParameters: CreateTenantOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTenant200Response> {
        const response = await this.createTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteAccessRuleRaw(requestParameters: DeleteAccessRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteAccessRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/delete/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAccessRule(requestParameters: DeleteAccessRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccessRuleRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteAccountRaw(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/accounts/delete/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteAccount(requestParameters: DeleteAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAccountRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteDeviceRaw(requestParameters: DeleteDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/delete`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDevice(requestParameters: DeleteDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDeviceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteDeviceGroupRaw(requestParameters: DeleteDeviceGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndDeleteDeviceGroupErrors>> {
        if (requestParameters['device_group_uuid'] == null) {
            throw new runtime.RequiredError(
                'device_group_uuid',
                'Required parameter "device_group_uuid" was null or undefined when calling deleteDeviceGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/device-groups/delete/{device_group_uuid}`.replace(`{${"device_group_uuid"}}`, encodeURIComponent(String(requestParameters['device_group_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async deleteDeviceGroup(requestParameters: DeleteDeviceGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndDeleteDeviceGroupErrors> {
        const response = await this.deleteDeviceGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteDirectoryRaw(requestParameters: DeleteDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['directory_uuid'] == null) {
            throw new runtime.RequiredError(
                'directory_uuid',
                'Required parameter "directory_uuid" was null or undefined when calling deleteDirectory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/delete/{directory_uuid}/directory`.replace(`{${"directory_uuid"}}`, encodeURIComponent(String(requestParameters['directory_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteDirectory(requestParameters: DeleteDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDirectoryRaw(requestParameters, initOverrides);
    }

    /**
     * Delete domain from split dns
     * Delete domain from split dns
     */
    async deleteDomainFromSplitDnsRaw(requestParameters: DeleteDomainFromSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['domain_uuid'] == null) {
            throw new runtime.RequiredError(
                'domain_uuid',
                'Required parameter "domain_uuid" was null or undefined when calling deleteDomainFromSplitDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/delete-domain/{domain_uuid}`.replace(`{${"domain_uuid"}}`, encodeURIComponent(String(requestParameters['domain_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete domain from split dns
     * Delete domain from split dns
     */
    async deleteDomainFromSplitDns(requestParameters: DeleteDomainFromSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDomainFromSplitDnsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteExitNodeRaw(requestParameters: DeleteExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteExitNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/delete-exit-node/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteExitNode(requestParameters: DeleteExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExitNodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteExtraDnsDomainRaw(requestParameters: DeleteExtraDnsDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteExtraDnsDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/delete-extra-dns-domain`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteExtraDnsDomain(requestParameters: DeleteExtraDnsDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExtraDnsDomainRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteExtraDnsRecordRaw(requestParameters: DeleteExtraDnsRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteExtraDnsRecord().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/delete-extra-dns-record`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteExtraDnsRecord(requestParameters: DeleteExtraDnsRecordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteExtraDnsRecordRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteLocalGroupRaw(requestParameters: DeleteLocalGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndDeleteLocalGroupErrors>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteLocalGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/local/delete/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async deleteLocalGroup(requestParameters: DeleteLocalGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndDeleteLocalGroupErrors> {
        const response = await this.deleteLocalGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteLocalOrInvitedUserRaw(requestParameters: DeleteLocalOrInvitedUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['user_uuid'] == null) {
            throw new runtime.RequiredError(
                'user_uuid',
                'Required parameter "user_uuid" was null or undefined when calling deleteLocalOrInvitedUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/{user_uuid}/delete-local`.replace(`{${"user_uuid"}}`, encodeURIComponent(String(requestParameters['user_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteLocalOrInvitedUser(requestParameters: DeleteLocalOrInvitedUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLocalOrInvitedUserRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteOidcProviderRaw(requestParameters: DeleteOidcProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['provider_uuid'] == null) {
            throw new runtime.RequiredError(
                'provider_uuid',
                'Required parameter "provider_uuid" was null or undefined when calling deleteOidcProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/oidc-provider/delete/{provider_uuid}`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters['provider_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteOidcProvider(requestParameters: DeleteOidcProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOidcProviderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deletePluginRaw(requestParameters: DeletePluginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['plugin_uuid'] == null) {
            throw new runtime.RequiredError(
                'plugin_uuid',
                'Required parameter "plugin_uuid" was null or undefined when calling deletePlugin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/plugins/{plugin_uuid}/delete`.replace(`{${"plugin_uuid"}}`, encodeURIComponent(String(requestParameters['plugin_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deletePlugin(requestParameters: DeletePluginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePluginRaw(requestParameters, initOverrides);
    }

    /**
     * Delete resolver
     * Delete resolver
     */
    async deleteResolverFromDomainInSplitDnsRaw(requestParameters: DeleteResolverFromDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['resolver_uuid'] == null) {
            throw new runtime.RequiredError(
                'resolver_uuid',
                'Required parameter "resolver_uuid" was null or undefined when calling deleteResolverFromDomainInSplitDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/delete-resolver/{resolver_uuid}`.replace(`{${"resolver_uuid"}}`, encodeURIComponent(String(requestParameters['resolver_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete resolver
     * Delete resolver
     */
    async deleteResolverFromDomainInSplitDns(requestParameters: DeleteResolverFromDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteResolverFromDomainInSplitDnsRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a rule from a ruleset  The ruleset is identified through the rule.
     * Deletes a rule from a ruleset
     */
    async deleteRuleFromRulesetRaw(requestParameters: DeleteRuleFromRulesetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['rule_uuid'] == null) {
            throw new runtime.RequiredError(
                'rule_uuid',
                'Required parameter "rule_uuid" was null or undefined when calling deleteRuleFromRuleset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/rulesets/delete-rule/{rule_uuid}`.replace(`{${"rule_uuid"}}`, encodeURIComponent(String(requestParameters['rule_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a rule from a ruleset  The ruleset is identified through the rule.
     * Deletes a rule from a ruleset
     */
    async deleteRuleFromRuleset(requestParameters: DeleteRuleFromRulesetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRuleFromRulesetRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a ruleset, its rules and instances
     * Deletes a ruleset, its rules and instances
     */
    async deleteRulesetRaw(requestParameters: DeleteRulesetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['ruleset_uuid'] == null) {
            throw new runtime.RequiredError(
                'ruleset_uuid',
                'Required parameter "ruleset_uuid" was null or undefined when calling deleteRuleset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/rulesets/{ruleset_uuid}/delete`.replace(`{${"ruleset_uuid"}}`, encodeURIComponent(String(requestParameters['ruleset_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a ruleset, its rules and instances
     * Deletes a ruleset, its rules and instances
     */
    async deleteRuleset(requestParameters: DeleteRulesetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRulesetRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a ruleset instance
     * Deletes a ruleset instance
     */
    async deleteRulesetInstanceRaw(requestParameters: DeleteRulesetInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['instance_uuid'] == null) {
            throw new runtime.RequiredError(
                'instance_uuid',
                'Required parameter "instance_uuid" was null or undefined when calling deleteRulesetInstance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/ruleset-instances/{instance_uuid}/delete`.replace(`{${"instance_uuid"}}`, encodeURIComponent(String(requestParameters['instance_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a ruleset instance
     * Deletes a ruleset instance
     */
    async deleteRulesetInstance(requestParameters: DeleteRulesetInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRulesetInstanceRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteSubnetRaw(requestParameters: DeleteSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subnet_uuid'] == null) {
            throw new runtime.RequiredError(
                'subnet_uuid',
                'Required parameter "subnet_uuid" was null or undefined when calling deleteSubnet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/delete-subnet/{subnet_uuid}`.replace(`{${"subnet_uuid"}}`, encodeURIComponent(String(requestParameters['subnet_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteSubnet(requestParameters: DeleteSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSubnetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteTagRaw(requestParameters: DeleteTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndDeleteTagErrors>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/delete/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async deleteTag(requestParameters: DeleteTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndDeleteTagErrors> {
        const response = await this.deleteTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteTenantRaw(requestParameters: DeleteTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling deleteTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants/delete/{tenant_uuid}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async deleteTenant(requestParameters: DeleteTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.deleteTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async disableExitNodeRaw(requestParameters: DisableExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling disableExitNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/disable-exit-node/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async disableExitNode(requestParameters: DisableExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.disableExitNodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async disableSubnetRaw(requestParameters: DisableSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subnet_uuid'] == null) {
            throw new runtime.RequiredError(
                'subnet_uuid',
                'Required parameter "subnet_uuid" was null or undefined when calling disableSubnet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/disable-subnet/{subnet_uuid}`.replace(`{${"subnet_uuid"}}`, encodeURIComponent(String(requestParameters['subnet_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async disableSubnet(requestParameters: DisableSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.disableSubnetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async dumpDeviceStateRaw(requestParameters: DumpDeviceStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling dumpDeviceState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/dump-state`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async dumpDeviceState(requestParameters: DumpDeviceStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.dumpDeviceStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async enableExitNodeRaw(requestParameters: EnableExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling enableExitNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/enable-exit-node/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async enableExitNode(requestParameters: EnableExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enableExitNodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async enableSubnetRaw(requestParameters: EnableSubnetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subnet_uuid'] == null) {
            throw new runtime.RequiredError(
                'subnet_uuid',
                'Required parameter "subnet_uuid" was null or undefined when calling enableSubnet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/enable-subnet/{subnet_uuid}`.replace(`{${"subnet_uuid"}}`, encodeURIComponent(String(requestParameters['subnet_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['EnableSubnetRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async enableSubnet(requestParameters: EnableSubnetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.enableSubnetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async expireDeviceRaw(requestParameters: ExpireDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling expireDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/expire`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async expireDevice(requestParameters: ExpireDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.expireDeviceRaw(requestParameters, initOverrides);
    }

    /**
     * Expires an invited user\'s invitation link  # Bad Request - if the `user_uuid` does not belong to an invited user
     * Expires an invited user\'s invitation link
     */
    async expireInvitationRaw(requestParameters: ExpireInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['user_uuid'] == null) {
            throw new runtime.RequiredError(
                'user_uuid',
                'Required parameter "user_uuid" was null or undefined when calling expireInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/expire-invitation/{user_uuid}`.replace(`{${"user_uuid"}}`, encodeURIComponent(String(requestParameters['user_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Expires an invited user\'s invitation link  # Bad Request - if the `user_uuid` does not belong to an invited user
     * Expires an invited user\'s invitation link
     */
    async expireInvitation(requestParameters: ExpireInvitationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.expireInvitationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async expireKeyRaw(requestParameters: ExpireKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling expireKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/pre-auth-keys/{uuid}/expire`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async expireKey(requestParameters: ExpireKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.expireKeyRaw(requestParameters, initOverrides);
    }

    /**
     * Expires any user\'s devices forcing him to reauthenticate them
     * Expires any user\'s devices forcing him to reauthenticate them
     */
    async expireUserDevicesRaw(requestParameters: ExpireUserDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling expireUserDevices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/{uuid}/expire-devices`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Expires any user\'s devices forcing him to reauthenticate them
     * Expires any user\'s devices forcing him to reauthenticate them
     */
    async expireUserDevices(requestParameters: ExpireUserDevicesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.expireUserDevicesRaw(requestParameters, initOverrides);
    }

    /**
     */
    async exportChangelogRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleChangelogEntry>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/changelog/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async exportChangelog(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleChangelogEntry> {
        const response = await this.exportChangelogRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get the access visualization graph
     * Get the access visualization graph
     */
    async getAccessGraphRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessGraphResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-visualization/graph`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get the access visualization graph
     * Get the access visualization graph
     */
    async getAccessGraph(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessGraphResponse> {
        const response = await this.getAccessGraphRaw(initOverrides);
        return await response.value();
    }

    /**
     * Detect problems in the access rule configuration
     * Detect problems in the access rule configuration
     */
    async getAccessProblemsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAccessProblemsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-visualization/problems`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Detect problems in the access rule configuration
     * Detect problems in the access rule configuration
     */
    async getAccessProblems(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAccessProblemsResponse> {
        const response = await this.getAccessProblemsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRuleOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllAccessRuleOptionsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/all-for-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRuleOptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllAccessRuleOptionsResponse> {
        const response = await this.getAllAccessRuleOptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccessRulesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullAccessRule>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccessRules(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullAccessRule> {
        const response = await this.getAllAccessRulesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllAccountsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleAccount>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/accounts/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllAccounts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleAccount> {
        const response = await this.getAllAccountsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllApprovedExitNodesRaw(requestParameters: GetAllApprovedExitNodesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetExitNodesResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllExitNodesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllApprovedExitNodes(requestParameters: GetAllApprovedExitNodesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetExitNodesResponseItem> {
        const response = await this.getAllApprovedExitNodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllDeviceGroupsRaw(requestParameters: GetAllDeviceGroupsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleDeviceGroup>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/device-groups/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllDeviceGroupsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllDeviceGroups(requestParameters: GetAllDeviceGroupsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleDeviceGroup> {
        const response = await this.getAllDeviceGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllDevicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllDevicesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllDevices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllDevicesResponse> {
        const response = await this.getAllDevicesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllDirectoriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleTagDirectory>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/directories/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllDirectories(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleTagDirectory> {
        const response = await this.getAllDirectoriesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllExtraDnsRaw(requestParameters: GetAllExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullExtraDnsDomain>> {
        const queryParameters: any = {};

        if (requestParameters['filter_dns'] != null) {
            queryParameters['filter_dns'] = requestParameters['filter_dns'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/get-all-extra-dns`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllExtraDns(requestParameters: GetAllExtraDnsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullExtraDnsDomain> {
        const response = await this.getAllExtraDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllGroupsRaw(requestParameters: GetAllGroupsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetAllGroupsResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllGroupsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllGroups(requestParameters: GetAllGroupsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetAllGroupsResponseItem> {
        const response = await this.getAllGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllOidcProviderRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleOidcProvider>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/oidc-provider`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllOidcProvider(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleOidcProvider> {
        const response = await this.getAllOidcProviderRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllPluginsRaw(requestParameters: GetAllPluginsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllPluginsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/plugins/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllPluginsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllPlugins(requestParameters: GetAllPluginsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllPluginsResponse> {
        const response = await this.getAllPluginsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllPreAuthKeysRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullHeadscalePreAuthKey>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/pre-auth-keys/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllPreAuthKeys(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullHeadscalePreAuthKey> {
        const response = await this.getAllPreAuthKeysRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllSubnetsRaw(requestParameters: GetAllSubnetsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetAllSubnetsResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllSubnetsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllSubnets(requestParameters: GetAllSubnetsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetAllSubnetsResponseItem> {
        const response = await this.getAllSubnetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllTagsRaw(requestParameters: GetAllTagsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllTagDirectoriesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetAllTagsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllTags(requestParameters: GetAllTagsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllTagDirectoriesResponse> {
        const response = await this.getAllTagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllTenantsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleTenant>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllTenants(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleTenant> {
        const response = await this.getAllTenantsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForGetAllUsersResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getAllUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForGetAllUsersResponse> {
        const response = await this.getAllUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getChangelogRaw(requestParameters: GetChangelogOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleChangelogEntry>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/changelog`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetChangelogRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getChangelog(requestParameters: GetChangelogOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleChangelogEntry> {
        const response = await this.getChangelogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDeletePreviewRaw(requestParameters: GetDeletePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDeletePreviewResponse>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling getDeletePreview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants/{tenant_uuid}/delete-preview`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDeletePreview(requestParameters: GetDeletePreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDeletePreviewResponse> {
        const response = await this.getDeletePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDeviceExtraDnsRaw(requestParameters: GetDeviceExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullExtraDnsDomain>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getDeviceExtraDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/get-device-extra-dns`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDeviceExtraDns(requestParameters: GetDeviceExtraDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullExtraDnsDomain> {
        const response = await this.getDeviceExtraDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDeviceFromIpRaw(requestParameters: GetDeviceFromIpRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeviceFromIpResponse>> {
        const queryParameters: any = {};

        if (requestParameters['ip'] != null) {
            queryParameters['ip'] = requestParameters['ip'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/get-device-from-ip`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDeviceFromIp(requestParameters: GetDeviceFromIpRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeviceFromIpResponse> {
        const response = await this.getDeviceFromIpRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDeviceGroupRaw(requestParameters: GetDeviceGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleDeviceGroupResponse>> {
        if (requestParameters['device_group_uuid'] == null) {
            throw new runtime.RequiredError(
                'device_group_uuid',
                'Required parameter "device_group_uuid" was null or undefined when calling getDeviceGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/device-groups/{device_group_uuid}`.replace(`{${"device_group_uuid"}}`, encodeURIComponent(String(requestParameters['device_group_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDeviceGroup(requestParameters: GetDeviceGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleDeviceGroupResponse> {
        const response = await this.getDeviceGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDevicesFromNameRaw(requestParameters: GetDevicesFromNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DevicesFromNameResponse>> {
        const queryParameters: any = {};

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/get-devices-from-name`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getDevicesFromName(requestParameters: GetDevicesFromNameRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DevicesFromNameResponse> {
        const response = await this.getDevicesFromNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the list of search domains
     * Retrieves the list of search domains
     */
    async getDnsSearchDomainsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleDnsSearchDomain>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/get-search-domains`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves the list of search domains
     * Retrieves the list of search domains
     */
    async getDnsSearchDomains(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleDnsSearchDomain> {
        const response = await this.getDnsSearchDomainsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getEphemeralDeviceSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEphemeralDeviceSettingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/ephemeral-device`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getEphemeralDeviceSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEphemeralDeviceSettingsResponse> {
        const response = await this.getEphemeralDeviceSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getGeneralSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGeneralSettingsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/general`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGeneralSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGeneralSettingsResponse> {
        const response = await this.getGeneralSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getGlobalDnsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullGlobalDns>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/get-global`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGlobalDns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullGlobalDns> {
        const response = await this.getGlobalDnsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getLdapSettingsRaw(requestParameters: GetLdapSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullLdapSettings>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling getLdapSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-ldap/get-settings/{tenant_uuid}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getLdapSettings(requestParameters: GetLdapSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullLdapSettings> {
        const response = await this.getLdapSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLocalAuthRequirementsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLocalAuthRequirementsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/local-auth-requirements`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getLocalAuthRequirements(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLocalAuthRequirementsResponse> {
        const response = await this.getLocalAuthRequirementsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getOidcSettingsRaw(requestParameters: GetOidcSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetOidcSettingsResponse>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling getOidcSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-oidc/{tenant_uuid}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getOidcSettings(requestParameters: GetOidcSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetOidcSettingsResponse> {
        const response = await this.getOidcSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPendingExitNodesRaw(requestParameters: GetPendingExitNodesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetExitNodesResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/get-pending-exit-nodes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetPendingExitNodesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPendingExitNodes(requestParameters: GetPendingExitNodesOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetExitNodesResponseItem> {
        const response = await this.getPendingExitNodesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPendingSubnetRoutesRaw(requestParameters: GetPendingSubnetRoutesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetPendingRoutesResponseItem>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/get-pending-routes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetPendingRoutesRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPendingSubnetRoutes(requestParameters: GetPendingSubnetRoutesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetPendingRoutesResponseItem> {
        const response = await this.getPendingSubnetRoutesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPluginVersionRaw(requestParameters: GetPluginVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullPluginSchema>> {
        if (requestParameters['plugin_uuid'] == null) {
            throw new runtime.RequiredError(
                'plugin_uuid',
                'Required parameter "plugin_uuid" was null or undefined when calling getPluginVersion().'
            );
        }

        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling getPluginVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/plugins/{plugin_uuid}/{version}`.replace(`{${"plugin_uuid"}}`, encodeURIComponent(String(requestParameters['plugin_uuid']))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPluginVersion(requestParameters: GetPluginVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullPluginSchema> {
        const response = await this.getPluginVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getPortalAccessGroupRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OptionalForSimpleGroup>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/portal-access-group`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPortalAccessGroup(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OptionalForSimpleGroup> {
        const response = await this.getPortalAccessGroupRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getPossibleExtraDnsForDeviceRaw(requestParameters: GetPossibleExtraDnsForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleExtraDnsDomain>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getPossibleExtraDnsForDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/get-possible-extra-dns-for-device`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getPossibleExtraDnsForDevice(requestParameters: GetPossibleExtraDnsForDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleExtraDnsDomain> {
        const response = await this.getPossibleExtraDnsForDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a single ruleset
     * Retrieves a single ruleset
     */
    async getRulesetRaw(requestParameters: GetRulesetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetRulesetResponse>> {
        if (requestParameters['ruleset_uuid'] == null) {
            throw new runtime.RequiredError(
                'ruleset_uuid',
                'Required parameter "ruleset_uuid" was null or undefined when calling getRuleset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/rulesets/{ruleset_uuid}`.replace(`{${"ruleset_uuid"}}`, encodeURIComponent(String(requestParameters['ruleset_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves a single ruleset
     * Retrieves a single ruleset
     */
    async getRuleset(requestParameters: GetRulesetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetRulesetResponse> {
        const response = await this.getRulesetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a single ruleset instance
     * Retrieves a single ruleset instance
     */
    async getRulesetInstanceRaw(requestParameters: GetRulesetInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FullRulesetInstance>> {
        if (requestParameters['instance_uuid'] == null) {
            throw new runtime.RequiredError(
                'instance_uuid',
                'Required parameter "instance_uuid" was null or undefined when calling getRulesetInstance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/ruleset-instances/{instance_uuid}`.replace(`{${"instance_uuid"}}`, encodeURIComponent(String(requestParameters['instance_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves a single ruleset instance
     * Retrieves a single ruleset instance
     */
    async getRulesetInstance(requestParameters: GetRulesetInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FullRulesetInstance> {
        const response = await this.getRulesetInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves an optionally filtered page of rulesets
     * Retrieves an optionally filtered page of rulesets
     */
    async getRulesetsPageRaw(requestParameters: GetRulesetsPageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForGetRulesetsPageResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/rulesets/get-page`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetRulesetsPageRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Retrieves an optionally filtered page of rulesets
     * Retrieves an optionally filtered page of rulesets
     */
    async getRulesetsPage(requestParameters: GetRulesetsPageOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForGetRulesetsPageResponse> {
        const response = await this.getRulesetsPageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getScimSettingsRaw(requestParameters: GetScimSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetScimSettingsResponse>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling getScimSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-scim/{tenant_uuid}/scim`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getScimSettings(requestParameters: GetScimSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetScimSettingsResponse> {
        const response = await this.getScimSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleDeviceRaw(requestParameters: GetSingleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleDeviceResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleDevice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleDevice(requestParameters: GetSingleDeviceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleDeviceResponse> {
        const response = await this.getSingleDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleGroupRaw(requestParameters: GetSingleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleGroupResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleGroup(requestParameters: GetSingleGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleGroupResponse> {
        const response = await this.getSingleGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleGroupMembersRaw(requestParameters: GetSingleGroupMembersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageForSimpleUser>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleGroupMembers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/{uuid}/members`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetSingleGroupMembersRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleGroupMembers(requestParameters: GetSingleGroupMembersOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageForSimpleUser> {
        const response = await this.getSingleGroupMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleOidcProviderRaw(requestParameters: GetSingleOidcProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimpleOidcProvider>> {
        if (requestParameters['provider_uuid'] == null) {
            throw new runtime.RequiredError(
                'provider_uuid',
                'Required parameter "provider_uuid" was null or undefined when calling getSingleOidcProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/oidc-provider/{provider_uuid}`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters['provider_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleOidcProvider(requestParameters: GetSingleOidcProviderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimpleOidcProvider> {
        const response = await this.getSingleOidcProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSinglePluginRaw(requestParameters: GetSinglePluginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSinglePluginResponse>> {
        if (requestParameters['plugin_uuid'] == null) {
            throw new runtime.RequiredError(
                'plugin_uuid',
                'Required parameter "plugin_uuid" was null or undefined when calling getSinglePlugin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/plugins/{plugin_uuid}`.replace(`{${"plugin_uuid"}}`, encodeURIComponent(String(requestParameters['plugin_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSinglePlugin(requestParameters: GetSinglePluginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSinglePluginResponse> {
        const response = await this.getSinglePluginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleSubnetRaw(requestParameters: GetSingleSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleSubnetResponse>> {
        if (requestParameters['subnet_uuid'] == null) {
            throw new runtime.RequiredError(
                'subnet_uuid',
                'Required parameter "subnet_uuid" was null or undefined when calling getSingleSubnet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/{subnet_uuid}`.replace(`{${"subnet_uuid"}}`, encodeURIComponent(String(requestParameters['subnet_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleSubnet(requestParameters: GetSingleSubnetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleSubnetResponse> {
        const response = await this.getSingleSubnetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleTenantRaw(requestParameters: GetSingleTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimpleTenant>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling getSingleTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants/{tenant_uuid}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleTenant(requestParameters: GetSingleTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimpleTenant> {
        const response = await this.getSingleTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSingleUserRaw(requestParameters: GetSingleUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleUserResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getSingleUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSingleUser(requestParameters: GetSingleUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleUserResponse> {
        const response = await this.getSingleUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSplitDnsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForFullSplitDnsDomain>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/get-split-dns`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSplitDns(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForFullSplitDnsDomain> {
        const response = await this.getSplitDnsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getTagRaw(requestParameters: GetTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSingleTagResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTag(requestParameters: GetTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSingleTagResponse> {
        const response = await this.getTagRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTenantDomainsRaw(requestParameters: GetTenantDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForGetTenantSplitDomainsResponseItem>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling getTenantDomains().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-dns/{tenant_uuid}/domains`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTenantDomains(requestParameters: GetTenantDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForGetTenantSplitDomainsResponseItem> {
        const response = await this.getTenantDomainsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTenantSearchDomainsRaw(requestParameters: GetTenantSearchDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTenantSearchDomainsResponse>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling getTenantSearchDomains().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-dns/{tenant_uuid}/search-domains`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getTenantSearchDomains(requestParameters: GetTenantSearchDomainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTenantSearchDomainsResponse> {
        const response = await this.getTenantSearchDomainsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all users that are not members of the given group.
     * Returns all users that are not members of the given group.
     */
    async getUsersNotInGroupRaw(requestParameters: GetUsersNotInGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListForSimpleUser>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getUsersNotInGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/{uuid}/users-not-in-group`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['GetUserNotInGroupRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns all users that are not members of the given group.
     * Returns all users that are not members of the given group.
     */
    async getUsersNotInGroup(requestParameters: GetUsersNotInGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListForSimpleUser> {
        const response = await this.getUsersNotInGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new search domain
     * Adds a new search domain
     */
    async insertDnsSearchDomainRaw(requestParameters: InsertDnsSearchDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForInsertDnsSearchDomainError>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/insert-search-domains`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['InsertDnsSearchDomainRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Adds a new search domain
     * Adds a new search domain
     */
    async insertDnsSearchDomain(requestParameters: InsertDnsSearchDomainOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForInsertDnsSearchDomainError> {
        const response = await this.insertDnsSearchDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new search domain  Similar to the dns::add_search_domain endpoint, but for a tenant specific
     * Adds a new search domain
     */
    async insertTenantDnsSearchDomainRaw(requestParameters: InsertTenantDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForInsertTenantSearchDomainErrors>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling insertTenantDnsSearchDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-dns/{tenant_uuid}/insert-search-domain`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['InsertTenantSearchDomainRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Adds a new search domain  Similar to the dns::add_search_domain endpoint, but for a tenant specific
     * Adds a new search domain
     */
    async insertTenantDnsSearchDomain(requestParameters: InsertTenantDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForInsertTenantSearchDomainErrors> {
        const response = await this.insertTenantDnsSearchDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async installPluginRaw(requestParameters: InstallPluginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['plugin_uuid'] == null) {
            throw new runtime.RequiredError(
                'plugin_uuid',
                'Required parameter "plugin_uuid" was null or undefined when calling installPlugin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/plugins/{plugin_uuid}/install`.replace(`{${"plugin_uuid"}}`, encodeURIComponent(String(requestParameters['plugin_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async installPlugin(requestParameters: InstallPluginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.installPluginRaw(requestParameters, initOverrides);
    }

    /**
     */
    async inviteUserRaw(requestParameters: InviteUserOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForSimpleInvitationLinkAndInviteUserErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['InviteUserRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async inviteUser(requestParameters: InviteUserOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForSimpleInvitationLinkAndInviteUserErrors> {
        const response = await this.inviteUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Moves a search domain from one index to another  This is implemented as a remove followed by an insert. Therefore, the `new_index` references to the list without the domain to move.  # Bad Request - if any index is out of bounds
     * Moves a search domain from one index to another
     */
    async moveDnsSearchDomainRaw(requestParameters: MoveDnsSearchDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/move-search-domains`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['MoveDnsSearchDomainRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Moves a search domain from one index to another  This is implemented as a remove followed by an insert. Therefore, the `new_index` references to the list without the domain to move.  # Bad Request - if any index is out of bounds
     * Moves a search domain from one index to another
     */
    async moveDnsSearchDomain(requestParameters: MoveDnsSearchDomainOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.moveDnsSearchDomainRaw(requestParameters, initOverrides);
    }

    /**
     */
    async moveTagToOtherDirectoryRaw(requestParameters: MoveTagToOtherDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/move-tag-from-directory`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['MoveTagToAnotherDirectoryRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async moveTagToOtherDirectory(requestParameters: MoveTagToOtherDirectoryRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.moveTagToOtherDirectoryRaw(requestParameters, initOverrides);
    }

    /**
     * Moves a search domain from one index to another  This is implemented as a remove followed by an insert. Therefore, the `new_index` references to the list without the domain to move.  # Bad Request - if any index is out of bounds
     * Moves a search domain from one index to another
     */
    async moveTenantDnsSearchDomainRaw(requestParameters: MoveTenantDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling moveTenantDnsSearchDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-dns/{tenant_uuid}/move-search-domains`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['MoveTenantSearchDomainRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Moves a search domain from one index to another  This is implemented as a remove followed by an insert. Therefore, the `new_index` references to the list without the domain to move.  # Bad Request - if any index is out of bounds
     * Moves a search domain from one index to another
     */
    async moveTenantDnsSearchDomain(requestParameters: MoveTenantDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.moveTenantDnsSearchDomainRaw(requestParameters, initOverrides);
    }

    /**
     */
    async openWebsocketRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/websocket`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async openWebsocket(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.openWebsocketRaw(initOverrides);
    }

    /**
     * Create a new invitation link for an invited user  This will expire any previous link.  # Bad Request - if the `user_uuid` does not belong to an invited user
     * Create a new invitation link for an invited user
     */
    async recreateInvitationRaw(requestParameters: RecreateInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['user_uuid'] == null) {
            throw new runtime.RequiredError(
                'user_uuid',
                'Required parameter "user_uuid" was null or undefined when calling recreateInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/recreate-invitation/{user_uuid}`.replace(`{${"user_uuid"}}`, encodeURIComponent(String(requestParameters['user_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RecreateInvitationRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a new invitation link for an invited user  This will expire any previous link.  # Bad Request - if the `user_uuid` does not belong to an invited user
     * Create a new invitation link for an invited user
     */
    async recreateInvitation(requestParameters: RecreateInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.recreateInvitationRaw(requestParameters, initOverrides);
    }

    /**
     */
    async rejectPendingExitNodeRaw(requestParameters: RejectPendingExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling rejectPendingExitNode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/exit-nodes/reject-pending-exit-node/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async rejectPendingExitNode(requestParameters: RejectPendingExitNodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rejectPendingExitNodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async rejectPendingSubnetRouterRaw(requestParameters: RejectPendingSubnetRouterOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/reject-pending-router`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RejectPendingSubnetRouterRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async rejectPendingSubnetRouter(requestParameters: RejectPendingSubnetRouterOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.rejectPendingSubnetRouterRaw(requestParameters, initOverrides);
    }

    /**
     */
    async reloadPluginsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/plugins/reload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async reloadPlugins(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.reloadPluginsRaw(initOverrides);
    }

    /**
     */
    async removeDeviceFromDeviceGroupRaw(requestParameters: RemoveDeviceFromDeviceGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['device_uuid'] == null) {
            throw new runtime.RequiredError(
                'device_uuid',
                'Required parameter "device_uuid" was null or undefined when calling removeDeviceFromDeviceGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{device_uuid}/remove-from-device-group`.replace(`{${"device_uuid"}}`, encodeURIComponent(String(requestParameters['device_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeDeviceFromDeviceGroup(requestParameters: RemoveDeviceFromDeviceGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeDeviceFromDeviceGroupRaw(requestParameters, initOverrides);
    }

    /**
     */
    async removeDeviceTagRaw(requestParameters: RemoveDeviceTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling removeDeviceTag().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/remove-tag`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeDeviceTag(requestParameters: RemoveDeviceTagRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeDeviceTagRaw(requestParameters, initOverrides);
    }

    /**
     * Removes a search domain  # Bad Request - if the index is out of bounds
     * Removes a search domain
     */
    async removeDnsSearchDomainRaw(requestParameters: RemoveDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['domain_index'] == null) {
            throw new runtime.RequiredError(
                'domain_index',
                'Required parameter "domain_index" was null or undefined when calling removeDnsSearchDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/remove-search-domains/{domain_index}`.replace(`{${"domain_index"}}`, encodeURIComponent(String(requestParameters['domain_index']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a search domain  # Bad Request - if the index is out of bounds
     * Removes a search domain
     */
    async removeDnsSearchDomain(requestParameters: RemoveDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeDnsSearchDomainRaw(requestParameters, initOverrides);
    }

    /**
     */
    async removeLocalGroupMemberRaw(requestParameters: RemoveLocalGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling removeLocalGroupMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/local/{uuid}/remove-member`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeLocalGroupMember(requestParameters: RemoveLocalGroupMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeLocalGroupMemberRaw(requestParameters, initOverrides);
    }

    /**
     */
    async removeSubnetRouterRaw(requestParameters: RemoveSubnetRouterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subnet_uuid'] == null) {
            throw new runtime.RequiredError(
                'subnet_uuid',
                'Required parameter "subnet_uuid" was null or undefined when calling removeSubnetRouter().'
            );
        }

        if (requestParameters['device_uuid'] == null) {
            throw new runtime.RequiredError(
                'device_uuid',
                'Required parameter "device_uuid" was null or undefined when calling removeSubnetRouter().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/{subnet_uuid}/remove-router/{device_uuid}`.replace(`{${"subnet_uuid"}}`, encodeURIComponent(String(requestParameters['subnet_uuid']))).replace(`{${"device_uuid"}}`, encodeURIComponent(String(requestParameters['device_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeSubnetRouter(requestParameters: RemoveSubnetRouterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeSubnetRouterRaw(requestParameters, initOverrides);
    }

    /**
     * Removes a search domain  # Bad Request - if the index is out of bounds
     * Removes a search domain
     */
    async removeTenantDnsSearchDomainRaw(requestParameters: RemoveTenantDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling removeTenantDnsSearchDomain().'
            );
        }

        if (requestParameters['domain_index'] == null) {
            throw new runtime.RequiredError(
                'domain_index',
                'Required parameter "domain_index" was null or undefined when calling removeTenantDnsSearchDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-dns/{tenant_uuid}/remove-search-domains/{domain_index}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))).replace(`{${"domain_index"}}`, encodeURIComponent(String(requestParameters['domain_index']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a search domain  # Bad Request - if the index is out of bounds
     * Removes a search domain
     */
    async removeTenantDnsSearchDomain(requestParameters: RemoveTenantDnsSearchDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeTenantDnsSearchDomainRaw(requestParameters, initOverrides);
    }

    /**
     */
    async removeTenantDomainRaw(requestParameters: RemoveTenantDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling removeTenantDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-dns/{tenant_uuid}/remove-domain`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RemoveTenantDomainRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async removeTenantDomain(requestParameters: RemoveTenantDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeTenantDomainRaw(requestParameters, initOverrides);
    }

    /**
     * Renews a local user\'s access to the vpn  # Bad Request - if the user is not a local one - if the user still has access - if the new access expiration lies in the past
     * Renews a local user\'s access to the vpn
     */
    async renewUserAccessRaw(requestParameters: RenewUserAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['user_uuid'] == null) {
            throw new runtime.RequiredError(
                'user_uuid',
                'Required parameter "user_uuid" was null or undefined when calling renewUserAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/{user_uuid}/renew-access`.replace(`{${"user_uuid"}}`, encodeURIComponent(String(requestParameters['user_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['RenewUserAccessRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Renews a local user\'s access to the vpn  # Bad Request - if the user is not a local one - if the user still has access - if the new access expiration lies in the past
     * Renews a local user\'s access to the vpn
     */
    async renewUserAccess(requestParameters: RenewUserAccessOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.renewUserAccessRaw(requestParameters, initOverrides);
    }

    /**
     * Revokes a local user\'s access to the vpn  This will expire all the user\'s devices and blocking him from reauthenticating them.  # Bad Request - if the user is not a local one - if the user\'s access has already expired or been revoked
     * Revokes a local user\'s access to the vpn
     */
    async revokeUserAccessRaw(requestParameters: RevokeUserAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['user_uuid'] == null) {
            throw new runtime.RequiredError(
                'user_uuid',
                'Required parameter "user_uuid" was null or undefined when calling revokeUserAccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/users/{user_uuid}/revoke-access`.replace(`{${"user_uuid"}}`, encodeURIComponent(String(requestParameters['user_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Revokes a local user\'s access to the vpn  This will expire all the user\'s devices and blocking him from reauthenticating them.  # Bad Request - if the user is not a local one - if the user\'s access has already expired or been revoked
     * Revokes a local user\'s access to the vpn
     */
    async revokeUserAccess(requestParameters: RevokeUserAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.revokeUserAccessRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setDeviceDnsnameRaw(requestParameters: SetDeviceDnsnameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForSetDeviceDnsnameErrors>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling setDeviceDnsname().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/set-dnsname`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetDeviceDnsnameRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setDeviceDnsname(requestParameters: SetDeviceDnsnameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForSetDeviceDnsnameErrors> {
        const response = await this.setDeviceDnsnameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setDeviceGroupDescriptionRaw(requestParameters: SetDeviceGroupDescriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['device_group_uuid'] == null) {
            throw new runtime.RequiredError(
                'device_group_uuid',
                'Required parameter "device_group_uuid" was null or undefined when calling setDeviceGroupDescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/device-groups/update/{device_group_uuid}/description`.replace(`{${"device_group_uuid"}}`, encodeURIComponent(String(requestParameters['device_group_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetDeviceGroupDescriptionRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setDeviceGroupDescription(requestParameters: SetDeviceGroupDescriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setDeviceGroupDescriptionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setDeviceGroupNameRaw(requestParameters: SetDeviceGroupNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetDeviceGroupNameErrors>> {
        if (requestParameters['device_group_uuid'] == null) {
            throw new runtime.RequiredError(
                'device_group_uuid',
                'Required parameter "device_group_uuid" was null or undefined when calling setDeviceGroupName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/device-groups/update/{device_group_uuid}/name`.replace(`{${"device_group_uuid"}}`, encodeURIComponent(String(requestParameters['device_group_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetDeviceGroupNameRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setDeviceGroupName(requestParameters: SetDeviceGroupNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetDeviceGroupNameErrors> {
        const response = await this.setDeviceGroupNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setDeviceStateDebugOnlyRaw(requestParameters: SetDeviceStateDebugOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling setDeviceStateDebugOnly().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/devices/{uuid}/set-state`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['MapResponse'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setDeviceStateDebugOnly(requestParameters: SetDeviceStateDebugOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setDeviceStateDebugOnlyRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setEphemeralDeviceSettingsRaw(requestParameters: SetEphemeralDeviceSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/ephemeral-device`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetEphemeralDeviceSettingsRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setEphemeralDeviceSettings(requestParameters: SetEphemeralDeviceSettingsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setEphemeralDeviceSettingsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setGeneralSettingsRaw(requestParameters: SetGeneralSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetGeneralSettingsErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/general`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetGeneralSettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setGeneralSettings(requestParameters: SetGeneralSettingsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetGeneralSettingsErrors> {
        const response = await this.setGeneralSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setLdapConnectionSettingsRaw(requestParameters: SetLdapConnectionSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetLdapConnectionSettingsErrors>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling setLdapConnectionSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-ldap/set-connection-settings/{tenant_uuid}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetLdapConnectionSettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setLdapConnectionSettings(requestParameters: SetLdapConnectionSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetLdapConnectionSettingsErrors> {
        const response = await this.setLdapConnectionSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setLdapQuerySettingsRaw(requestParameters: SetLdapQuerySettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetLdapSettingsErrors>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling setLdapQuerySettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-ldap/set-query-settings/{tenant_uuid}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetLdapQuerySettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setLdapQuerySettings(requestParameters: SetLdapQuerySettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetLdapSettingsErrors> {
        const response = await this.setLdapQuerySettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setLocalAuthRequirementsRaw(requestParameters: SetLocalAuthRequirementsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/local-auth-requirements`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetLocalAuthRequirementsRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setLocalAuthRequirements(requestParameters: SetLocalAuthRequirementsOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setLocalAuthRequirementsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setOidcSettingsRaw(requestParameters: SetOidcSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling setOidcSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-oidc/{tenant_uuid}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetOidcSettingsRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setOidcSettings(requestParameters: SetOidcSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setOidcSettingsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setPortalAccessGroupRaw(requestParameters: SetPortalAccessGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/settings/portal-access-group`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SingleUuid'],
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async setPortalAccessGroup(requestParameters: SetPortalAccessGroupRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.setPortalAccessGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setScimSettingsRaw(requestParameters: SetScimSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling setScimSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-scim/{tenant_uuid}/scim`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetScimSettingsRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setScimSettings(requestParameters: SetScimSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setScimSettingsRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setSubnetDescriptionRaw(requestParameters: SetSubnetDescriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['subnet_uuid'] == null) {
            throw new runtime.RequiredError(
                'subnet_uuid',
                'Required parameter "subnet_uuid" was null or undefined when calling setSubnetDescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/subnets/set-subnet-description/{subnet_uuid}`.replace(`{${"subnet_uuid"}}`, encodeURIComponent(String(requestParameters['subnet_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetSubnetDescriptionRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setSubnetDescription(requestParameters: SetSubnetDescriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setSubnetDescriptionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setTagDescriptionRaw(requestParameters: SetTagDescriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tag_uuid'] == null) {
            throw new runtime.RequiredError(
                'tag_uuid',
                'Required parameter "tag_uuid" was null or undefined when calling setTagDescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/update/{tag_uuid}/description`.replace(`{${"tag_uuid"}}`, encodeURIComponent(String(requestParameters['tag_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetTagDescriptionRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setTagDescription(requestParameters: SetTagDescriptionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setTagDescriptionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async setTagNameRaw(requestParameters: SetTagNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetTagNameErrors>> {
        if (requestParameters['tag_uuid'] == null) {
            throw new runtime.RequiredError(
                'tag_uuid',
                'Required parameter "tag_uuid" was null or undefined when calling setTagName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/update/{tag_uuid}/name`.replace(`{${"tag_uuid"}}`, encodeURIComponent(String(requestParameters['tag_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetTagNameRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setTagName(requestParameters: SetTagNameOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetTagNameErrors> {
        const response = await this.setTagNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async testLdapQuerySettingsRaw(requestParameters: TestLdapQuerySettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForTestLdapSearchResponseAndTestLdapSettingsErrors>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling testLdapQuerySettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants-ldap/test-query-settings/{tenant_uuid}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetLdapQuerySettingsRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async testLdapQuerySettings(requestParameters: TestLdapQuerySettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForTestLdapSearchResponseAndTestLdapSettingsErrors> {
        const response = await this.testLdapQuerySettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateAccessRuleRaw(requestParameters: UpdateAccessRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateAccessRule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/access-rules/update/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateAccessRuleRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateAccessRule(requestParameters: UpdateAccessRuleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateAccessRuleRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateDirectoryRaw(requestParameters: UpdateDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndUpdateTagDirectoryErrors>> {
        if (requestParameters['directory_uuid'] == null) {
            throw new runtime.RequiredError(
                'directory_uuid',
                'Required parameter "directory_uuid" was null or undefined when calling updateDirectory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tags/update/{directory_uuid}/directory`.replace(`{${"directory_uuid"}}`, encodeURIComponent(String(requestParameters['directory_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateTagDirectoryRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateDirectory(requestParameters: UpdateDirectoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndUpdateTagDirectoryErrors> {
        const response = await this.updateDirectoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update domain
     * Update domain
     */
    async updateDomainInSplitDnsRaw(requestParameters: UpdateDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndUpdateSplitDnsDomainError>> {
        if (requestParameters['domain_uuid'] == null) {
            throw new runtime.RequiredError(
                'domain_uuid',
                'Required parameter "domain_uuid" was null or undefined when calling updateDomainInSplitDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/update-domain/{domain_uuid}`.replace(`{${"domain_uuid"}}`, encodeURIComponent(String(requestParameters['domain_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateSplitDnsDomainRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update domain
     * Update domain
     */
    async updateDomainInSplitDns(requestParameters: UpdateDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndUpdateSplitDnsDomainError> {
        const response = await this.updateDomainInSplitDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateExtraDnsDomainRaw(requestParameters: UpdateExtraDnsDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForUpdateExtraDnsDomainError>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateExtraDnsDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/{uuid}/update-extra-dns`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateExtraDnsDomainRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateExtraDnsDomain(requestParameters: UpdateExtraDnsDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForUpdateExtraDnsDomainError> {
        const response = await this.updateExtraDnsDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateExtraDnsRecordRaw(requestParameters: UpdateExtraDnsRecordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndUpdateExtraDnsRecordError>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateExtraDnsRecord().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/records/{uuid}/update-extra-dns-record`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateExtraDnsRecordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateExtraDnsRecord(requestParameters: UpdateExtraDnsRecordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndUpdateExtraDnsRecordError> {
        const response = await this.updateExtraDnsRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateGlobalDnsRaw(requestParameters: UpdateGlobalDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndUpdateGlobalDnsErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/update-global`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['FullGlobalDns'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateGlobalDns(requestParameters: UpdateGlobalDnsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndUpdateGlobalDnsErrors> {
        const response = await this.updateGlobalDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateGroupRaw(requestParameters: UpdateGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling updateGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/groups/{uuid}/update`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateGroupRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateGroup(requestParameters: UpdateGroupOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateGroupRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateOidcProviderRaw(requestParameters: UpdateOidcProviderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForUpdateOidcProviderErrors>> {
        if (requestParameters['provider_uuid'] == null) {
            throw new runtime.RequiredError(
                'provider_uuid',
                'Required parameter "provider_uuid" was null or undefined when calling updateOidcProvider().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/oidc-provider/update/{provider_uuid}`.replace(`{${"provider_uuid"}}`, encodeURIComponent(String(requestParameters['provider_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateOidcProviderRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateOidcProvider(requestParameters: UpdateOidcProviderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForUpdateOidcProviderErrors> {
        const response = await this.updateOidcProviderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updatePluginRaw(requestParameters: UpdatePluginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['plugin_uuid'] == null) {
            throw new runtime.RequiredError(
                'plugin_uuid',
                'Required parameter "plugin_uuid" was null or undefined when calling updatePlugin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/frontend/v1/internal/plugins/{plugin_uuid}/update`.replace(`{${"plugin_uuid"}}`, encodeURIComponent(String(requestParameters['plugin_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePlugin(requestParameters: UpdatePluginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePluginRaw(requestParameters, initOverrides);
    }

    /**
     * Update resolver
     * Update resolver
     */
    async updateResolverInDomainInSplitDnsRaw(requestParameters: UpdateResolverInDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndUpdateSplitDnsResolverErrors>> {
        if (requestParameters['resolver_uuid'] == null) {
            throw new runtime.RequiredError(
                'resolver_uuid',
                'Required parameter "resolver_uuid" was null or undefined when calling updateResolverInDomainInSplitDns().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/dns/update-resolver/{resolver_uuid}`.replace(`{${"resolver_uuid"}}`, encodeURIComponent(String(requestParameters['resolver_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateSplitDnsResolverRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update resolver
     * Update resolver
     */
    async updateResolverInDomainInSplitDns(requestParameters: UpdateResolverInDomainInSplitDnsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndUpdateSplitDnsResolverErrors> {
        const response = await this.updateResolverInDomainInSplitDnsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates a ruleset\'s rule
     * Updates a ruleset\'s rule
     */
    async updateRuleInRulesetRaw(requestParameters: UpdateRuleInRulesetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['rule_uuid'] == null) {
            throw new runtime.RequiredError(
                'rule_uuid',
                'Required parameter "rule_uuid" was null or undefined when calling updateRuleInRuleset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/rulesets/update-rule/{rule_uuid}`.replace(`{${"rule_uuid"}}`, encodeURIComponent(String(requestParameters['rule_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateRuleInRulesetRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates a ruleset\'s rule
     * Updates a ruleset\'s rule
     */
    async updateRuleInRuleset(requestParameters: UpdateRuleInRulesetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateRuleInRulesetRaw(requestParameters, initOverrides);
    }

    /**
     * Updates a ruleset
     * Updates a ruleset
     */
    async updateRulesetRaw(requestParameters: UpdateRulesetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['ruleset_uuid'] == null) {
            throw new runtime.RequiredError(
                'ruleset_uuid',
                'Required parameter "ruleset_uuid" was null or undefined when calling updateRuleset().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/rulesets/{ruleset_uuid}/update`.replace(`{${"ruleset_uuid"}}`, encodeURIComponent(String(requestParameters['ruleset_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateRulesetRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates a ruleset
     * Updates a ruleset
     */
    async updateRuleset(requestParameters: UpdateRulesetOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateRulesetRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateTenantRaw(requestParameters: UpdateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormErrorResponseForUpdateTenantErrors>> {
        if (requestParameters['tenant_uuid'] == null) {
            throw new runtime.RequiredError(
                'tenant_uuid',
                'Required parameter "tenant_uuid" was null or undefined when calling updateTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/frontend/v1/internal/tenants/update/{tenant_uuid}`.replace(`{${"tenant_uuid"}}`, encodeURIComponent(String(requestParameters['tenant_uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateTenantRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async updateTenant(requestParameters: UpdateTenantOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormErrorResponseForUpdateTenantErrors> {
        const response = await this.updateTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
